module.exports = __webpack_public_path__ + "static/media/fullscreen-icon.21939d50.svg";